import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import React from 'react';
import Button from '@tencent/dui/lib/components/Button';
import SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import ScaleSlide from '@editor/src/page/index/components/canvas/scale-slide';
import { RenderPostionType } from '@src/js/constant';
import i18n from '@i18next/i18n';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

interface ISlideContentListModalProps {
    originList: ISlideModel[],
    previewList: ISlideModel[],
    slideIndexArray: number[]
    originRects?: Map<number, IRect[]>,
    previewRects?: Map<number, IRect[]>,
    slideWidth: number,
    slideHeight: number,
    onConfirmButtonClick: (clickEvent) => void,
}

export interface ISlideContentListModalState {
    scaleSlideWidth: number;
    scaleSlideHeight: number;
}

/**
 * 预览列表
 */
export class SlideContentList extends React.Component<ISlideContentListModalProps, ISlideContentListModalState> {
    private cellHeight: number;

    public constructor(props: ISlideContentListModalProps) {
        super(props);
    }

    public render() {
        const { originList, previewList, slideIndexArray,
            originRects, previewRects,
            slideWidth, slideHeight } = this.props;
        if (!originList || !previewList) return null;
        // 再修改uiModel的frame，使得标题对齐
        const cellWidth = 480;
        this.cellHeight = cellWidth / slideWidth * slideHeight;
        const scale = 480 / slideWidth;
        return (
            <>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-around',
                    width: '100%',
                    height: '22px',
                }}>
                    <div style={{ position: 'relative', width: '970px' }}>
                        <div style={{ position: 'absolute', fontSize: '14px', fontWeight: 500, left: 0 }}>
                            {i18n.t('调整前')}
                        </div>
                        <div style={{ position: 'absolute', left: '485px', fontWeight: 500, fontSize: '14px' }}>
                            {i18n.t('调整后')}
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        width: '100%',
                        height: '450px',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            textAlign: 'center',
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                overflowY: 'scroll',
                                overflowX: 'hidden',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-around',
                                }}
                            >
                                {
                                    originList?.map((slideModel: SlideModel, index) => (
                                        <div
                                            key={slideModel.key}
                                            style={{
                                                position: 'relative',
                                                width: '964px',
                                                minHeight: `${this.cellHeight + 10}px`,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: 'relative',
                                                }}
                                            >
                                                <ScaleSlide
                                                    width={cellWidth}
                                                    height={this.cellHeight}
                                                    isShown={true}
                                                    slideModel={slideModel}
                                                    buildRenderTreeAsync={false}
                                                    shouldUpdate={true}
                                                    fromScale={0}
                                                    region={RenderPostionType.PAGINGSELECTION}
                                                    isTemplate={false}
                                                />
                                                {
                                                    this.renderSlideNumber(slideIndexArray[index])
                                                }
                                                {
                                                    originRects?.get(index)?.map(rect => this.renderRect(rect, scale))
                                                }
                                            </div>
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    left: `${cellWidth + 5}px`,
                                                }}
                                            >
                                                <ScaleSlide
                                                    width={cellWidth}
                                                    height={this.cellHeight}
                                                    isShown={true}
                                                    slideModel={previewList[index]}
                                                    buildRenderTreeAsync={false}
                                                    shouldUpdate={true}
                                                    fromScale={0}
                                                    region={RenderPostionType.PAGINGSELECTION}
                                                    isTemplate={false}
                                                />
                                                {
                                                    this.renderSlideNumber(slideIndexArray[index])
                                                }
                                                {
                                                    previewRects?.get(index)?.map(rect => this.renderRect(rect, scale))
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Button
                    type='primary'
                    size='small'
                    style={{
                        position: 'absolute',
                        bottom: '20px',
                        right: '40px',
                    }}
                    onClick={this.props.onConfirmButtonClick}
                >
                    {i18n.t('确认调整')}
                </Button>
            </>
        );
    }


    private renderRect(rect: IRect, scale: number) {
        const renderRect = {
            left: rect.left * scale,
            top: rect.top * scale,
            width: rect.width * scale,
            height: rect.height * scale,
        };
        return <div
            style={{
                position: 'absolute',
                ...renderRect,
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: 'red',
            }}
        >
        </div>;
    }

    private renderSlideNumber(slideIndex: number) {
        return <div
            style={{
                position: 'absolute',
                left: '2px',
                top: '2px',
                height: '16px',
                fontSize: '12px',
                lineHeight: '16px',
                textAlign: 'center',
                zIndex: 1,
                borderRadius: '2px',
                color: 'white',
                borderColor: 'white',
                borderStyle: 'solid',
                borderWidth: '1px',
                backgroundColor: 'rgba(0,0,0,.5)',
                minWidth: '24px',
            }}
        >{slideIndex + 1}</div>;
    }
}
